import React from 'react';
import { Modal, Descriptions, Tabs } from 'antd';
import moment from 'moment';
import styles from './index.less';
const { TabPane } = Tabs;
const { Item } = Descriptions;

const BPSResult = ({ onCancel, result = {} }) => {
  const modalProps = {
    title: 'BPS记录',
    footer: null,
    visible: true,
    onCancel,
    className: styles['bps-result-modal'],
    width: 900,
  };
  console.log(result)
  // const { menstrualHistoryReq = {}, fatherInformationReq = {}, motherInformationReq = {} } = result;
  const menstrualHistoryReq = result.menstrualHistoryReq || {}
  const fatherInformationReq = result.fatherInformationReq || {}
  const motherInformationReq = result.motherInformationReq || {}
    console.log(menstrualHistoryReq)
  return (
    <Modal {...modalProps}>
      <div className="result-summary">
        <Tabs defaultActiveKey="1">
          <TabPane tab="临床症状" key="1">
            <div className="summary-label-medal">临床症状</div>
            <div className="summary-content">
              <Descriptions column={2}>
                <Item label="主诉">{result.chiefComplaint}</Item>
                <Item label="现病史">{result.historyOfPresentIllness}</Item>
              </Descriptions>
            </div>
            <div className="summary-label">精神状况评估</div>
            <div className="summary-content">
              <Descriptions column={2}>
                <Item label="睡眠状态">{result.sleepState}</Item>
                <Item label="饮食状况">{result.dietState}</Item>
                <Item label="生活自理">{result.performanceState}</Item>
                <Item label="风险评估">{result.riskEvaluation}</Item>
                <Item label="对疾病认识态度">{result.attitudeTowardsDisease}</Item>
              </Descriptions>
            </div>
            <div className="summary-label">既往史</div>
            <div className="summary-content">
              <Descriptions column={2}>
                {/* <Item label="躯体疾病史">{result.physicalDisease}</Item>
                <Item label="其他躯体疾病">{result.otherPhysicalDisease}</Item>
                <Item label="精神疾病史">{result.mentalDisease}</Item> */}
                <Item label="重大病史">{result.significantMedicalHistory}</Item>
                <Item label="食物药物过敏史">{result.allergicHistory}</Item>
              </Descriptions>
            </div>
            <div className="summary-label">遗传史</div>
            <div className="summary-content">
              <Descriptions column={2}>
                <Item label="遗传疾病">{result.hereditaryDisease}</Item>
                <Item label="父系精神病史">{result.paternalPsychiatricHistory}</Item>
                <Item label="母系精神病史">{result.maternalPsychiatricHistory}</Item>
              </Descriptions>
            </div>
            <div className="summary-label">月经史</div>
            <div className="summary-content">
              <Descriptions column={2}>
                <Item label="月经史">
                  {[
                    menstrualHistoryReq.menarcheAge
                      ? `初潮${menstrualHistoryReq.menarcheAge}岁`
                      : '',
                    menstrualHistoryReq.menstrualPeriod
                      ? `行经期${menstrualHistoryReq.menstrualPeriod}天`
                      : '',
                    menstrualHistoryReq.menstrualCycle
                      ? `月经周期${menstrualHistoryReq.menstrualCycle}天`
                      : '',
                    menstrualHistoryReq.lastMenstrualCycle
                      ? `末次月经日期${moment(menstrualHistoryReq.lastMenstrualCycle).format(
                        'YYYY-MM-DD'
                      )}`
                      : '',
                  ]
                    .filter(_ => _)
                    .join(',')}
                </Item>
                <Item label="平素月经情况">{menstrualHistoryReq.regularMenstruation}</Item>
                <Item label="概念化总结">{result.physiologySummarize}</Item>
              </Descriptions>
            </div>
          </TabPane>
          <TabPane tab="人格类型" key="2">
            <div className="summary-label">人格特征</div>
            <div className="summary-content">
              <Descriptions column={2}>
                <Item label="主观评估判断">{result.subjectiveEvaluationJudgment}</Item>
                <Item label="情绪特点">{result.emotionalCharacteristics}</Item>
                <Item label="其他量表结果参考">{result.questionnaireResults}</Item>
              </Descriptions>
            </div>
            <div className="summary-label">早期记忆／经历</div>
            <div className="summary-content">
              <Descriptions column={2}>
                <Item label="母孕期">
                  {result.howManyChild ? `第${result.howManyChild}胎` : ''}
                  {result.birthStatus}
                </Item>
                <Item label="生长发育(0-6岁左右)体格发育">{result.physicalGrowth}</Item>
                <Item label="感统失调">{result.feelingSystemDisorders}</Item>
                <Item label="神经系统疾病史">{result.historyOfNervousSystemDisease}</Item>
                <Item label="重要的童年经历/记忆">{result.importantChildhoodExperiencesAndMemories}</Item>
              </Descriptions>
            </div>
            <div className="summary-label">个人史</div>
            <div className="summary-content">
              <Descriptions column={2}>
                <Item label="兴趣爱好">{result.hobby}</Item>
                {/* <Item label="其他兴趣爱好">{result.otherHobby}</Item> */}
                <Item label="学习成绩">{result.schoolRecord}</Item>
                <Item label="重要经历概述">{result.schoolRecordOverview}</Item>
                {/* <Item label="人际关系">{result.relationship}</Item>
                <Item label="重要经历概述">{result.relationshipOverview}</Item> */}
                <Item label="不良嗜好">
                  {result.badAddiction}
                  {result.otherBadAddiction}
                </Item>
                <Item label="重要经历概述">{result.badAddictionOverview}</Item>
                <Item label="其他">{result.otherPersonalLife}</Item>
                <Item label="概念化总结">{result.psychologySummarize}</Item>
              </Descriptions>
            </div>
          </TabPane>
          <TabPane tab="原生家庭" key="3">
            <div className="summary-label">双亲信息</div>
            <div className="summary-content">
              <Descriptions column={2}>
                <Item label="父亲信息">
                  {[
                    fatherInformationReq.life,
                    fatherInformationReq.personalityCharacteristic,
                    fatherInformationReq.emotionalCharacteristic,
                  ]
                    .filter(_ => _)
                    .join('，')}
                </Item>
                {/* <Item label="病史">
                  {fatherInformationReq.historyOfMajorIllnessAndMentalIllness}
                </Item> */}
                <Item label="人际互动模式">
                  {fatherInformationReq.briefDescriptionOfInterpersonalInteractionPatterns}
                </Item>
                <Item label="个人重要经历">
                  {fatherInformationReq.briefDescriptionOfInterpersonalInteractionPatterns}
                </Item>
                <Item label="母亲信息">
                  {[
                    motherInformationReq.life,
                    motherInformationReq.personalityCharacteristic,
                    motherInformationReq.emotionalCharacteristic,
                  ]
                    .filter(_ => _)
                    .join('，')}
                </Item>
                {/* <Item label="病史">
                  {motherInformationReq.historyOfMajorIllnessAndMentalIllness}
                </Item> */}
                <Item label="人际互动模式">
                  {motherInformationReq.briefDescriptionOfInterpersonalInteractionPatterns}
                </Item>
                <Item label="个人重要经历">
                  {motherInformationReq.briefDescriptionOfInterpersonalInteractionPatterns}
                </Item>
                <Item label="父母互动模式">
                  {motherInformationReq.parentInteractionModeDescription}
                </Item>
              </Descriptions>
            </div>
            <div className="summary-label">父母教养方式</div>
            <div className="summary-content">
              <Descriptions column={2}>
                {/* <Item label="相处方式">{result.getAlongWay}</Item>
                <Item label="简要描述">{result.parentingStyleDescription}</Item> */}
                <Item label="教养方式">{result.parentingStyles}</Item>
                <Item label="简要描述">{result.descriptionOfParentingStyle}</Item>
                <Item label="与父亲关系">{result.relationshipWithFather}</Item>
                <Item label="与母亲关系">{result.relationshipWithMother}</Item>
                <Item label="与兄弟姐妹关系">{result.relationshipWithSiblings}</Item>
              </Descriptions>
            </div>
            <div className="summary-label">其他</div>
            <div className="summary-content">
              <Descriptions column={2}>
                <Item label="简要描述">{result.generalCharacterization}</Item>
                <Item label="概念化总结">{result.psychologySummarize}</Item>
              </Descriptions>
            </div>
          </TabPane>
          <TabPane tab="婚姻家庭适应" key="4">
            <div className="summary-label">婚姻恋爱情况</div>
            <div className="summary-content">
              <Descriptions column={2}>
                <Item label="恋爱史">
                  {[
                    result.ageOfLove
                      ? `${result.ageOfLove}岁开始恋爱`
                      : '',
                    result.numberOfLove
                      ? `恋爱${result.numberOfLove}次`
                      : '',
                  ]
                    .filter(_ => _)
                    .join(',')}
                </Item>
                <Item label="简述恋爱史">{result.briefHistoryOfLove}</Item>

                <Item label="婚恋情况">
                  {[
                    result.ageOfMarriage
                      ? `${result.ageOfMarriage}岁结婚`
                      : '',
                    result.historyOfMarriage
                      ? `婚史${result.historyOfMarriage}年`
                      : '',
                  ]
                    .filter(_ => _)
                    .join(',')}
                </Item>
                <Item label="配偶">
                  {[
                    result.spouseSituation
                      ? `${result.spouseSituation}`
                      : '',
                    result.ageOfSpouseDeath
                      ? `死亡年龄${result.ageOfSpouseDeath}`
                      : '',
                    result.causeOfDeath
                      ? `${result.causeOfDeath}`
                      : '',
                  ]
                    .filter(_ => _)
                    .join(',')}
                </Item>
                <Item label="简述婚姻史">{result.briefHistoryOfMarriage}</Item>
                <Item label="当前配偶／恋爱对象">
                  {[
                    result.spousePersonalityCharacteristics
                      ? `人格特点：${result.spousePersonalityCharacteristics}`
                      : '',
                    result.spousalEmotionalCharacteristics
                      ? `情绪特点：${result.spousalEmotionalCharacteristics}`
                      : '',
                  ]
                    .filter(_ => _)
                    .join(',')}
                </Item>
                <Item label="人际互动模式">{result.spouseInterpersonalInteractionMode}</Item>
                <Item label="恋爱关系／夫妻关系">{result.loveRelationshipOrMarriageRelationship}</Item>
              </Descriptions>
            </div>
            <div className="summary-label">当前家庭情况</div>
            <div className="summary-content">
              <Descriptions column={2}>
                {/* <Item label="家族结构">{result.familyStructure}</Item>
                <Item label="家谱图">{result.genogram}</Item> */}
                <Item label="新家庭融合情况">
                  {[
                    result.livingWithElders
                      ? `与老人：${result.livingWithElders}`
                      : '',
                    result.relationshipWithElders
                      ? `相处关系：${result.relationshipWithElders}`
                      : '',
                  ]
                    .filter(_ => _)
                    .join(',')}
                </Item>
                <Item label="情况简述">{result.relationshipWithEldersDescription}</Item>
                <Item label="生育">
                  {result.whetherFertility === '有'
                    ? `${
                    result.numberOfSon
                      ? `儿子${result.numberOfSon}名${
                      result.ageOfSon ? `,${result.ageOfSon}岁` : ''
                      }`
                      : ''
                    }${result.numberOfSon ? '；' : ''}${
                    result.numberOfDaughter
                      ? `女儿${result.numberOfDaughter}名${
                      result.ageOfDaughter ? `,${result.ageOfDaughter}岁` : ''
                      }`
                      : ''
                    }`
                    : result.whetherFertility === '无'
                      ? '无'
                      : ''}
                </Item>
                <Item label="亲子关系">
                  {[
                    result.livingWithJunior
                      ? `与子女：${result.livingWithJunior}`
                      : '',
                    result.relationshipWithJunior
                      ? `相处关系：${result.relationshipWithJunior}`
                      : '',
                  ]
                    .filter(_ => _)
                    .join(',')}
                </Item>
                <Item label="情况简述">{result.relationshipWithJuniorDescription}</Item>
              </Descriptions>
            </div>
            <div className="summary-label">重大影响事件</div>
            <div className="summary-content">
              <Descriptions column={2}>
                <Item label="简要概述">{result.generalCharacterization}</Item>
                <Item label="概念化总结">{result.socialSummarize}</Item>
              </Descriptions>
            </div>
          </TabPane>
          <TabPane tab="社会功能" key="5">
            <div className="summary-label">工作/学习状况及所遇挫折</div>
            <div className="summary-content">
              <Descriptions column={2}>
                <Item label="工作学习状态">{result.recentChange}</Item>
                <Item label="简要概述">{result.overviewOfWorkOrStudyAbility}</Item>
              </Descriptions>
            </div>
            <div className="summary-label">人际关系情况</div>
            <div className="summary-content">
              <Descriptions column={2}>
                <Item label="人际状况">{result.recentRelationshipsWithFriendsAndColleagues}</Item>
                <Item label="简要概述">
                  {result.recentRelationshipsWithFriendsAndColleaguesDescription}
                </Item>
              </Descriptions>
            </div>
            <div className="summary-label">其他</div>
            <div className="summary-content">
              <Descriptions column={2}>
                <Item label="简要概述">{result.generalCharacterDescription}</Item>
                <Item label="概念化总结">{result.socialSummarize}</Item>
              </Descriptions>
            </div>
          </TabPane>


        </Tabs>
      </div>
    </Modal>
  );
};

export default BPSResult;
